export const LOCATIONS = {
    1: {
        id: 1,
        name: `Smartrak office`,
        isDeleted: false,
        hasPlant: true,
    },
    2: {
        id: 2,
        name: `Auckland`,
        isDeleted: false,
        hasPlant: true,
    },
    3: {
        id: 3,
        name: `Hamilton`,
        isDeleted: false,
        hasPlant: true,
    },
    4: {
        id: 4,
        name: `Japan`,
        isDeleted: false,
        hasPlant: false,
    },
    5: {
        id: 5,
        name: `China`,
        isDeleted: true,
        hasPlant: false,
    },
    6: {
        id: 6,
        name: `Samoa`,
        isDeleted: true,
        hasPlant: false,
    },
    7: {
        id: 7,
        name: `Somewhere else with a long name`,
        isDeleted: false,
        hasPlant: false,
    },
    8: {
        id: 8,
        name: `Another place`,
        isDeleted: false,
        hasPlant: true,
    },
    9: {
        id: 9,
        name: `Base location`,
        isDeleted: false,
        hasPlant: true,
    },
    10: {
        id: 10,
        name: `Carpark 17`,
        hasPlant: false,
    },
    11: {
        id: 11,
        name: `Chocolate factory`,
        hasPlant: false,
    },
    12: {
        id: 12,
        name: `Research Motors`,
        hasPlant: true,
    },
    13: {
        id: 13,
        name: `Bills Subs`,
        hasPlant: true,
    },
    14: {
        id: 15,
        name: `Countdown`,
        hasPlant: true,
    },
    15: {
        id: 15,
        name: `Noel Leeming`,
        hasPlant: true,
    },
    16: {
        id: 16,
        name: `Stewart Island`,
        hasPlant: false,
    },
    17: {
        id: 17,
        name: `Mount Ruapehu`,
        hasPlant: true,
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/locations.js